import "../css/styles.css";
import { ArcherContainer, ArcherElement } from "react-archer";
import React, { useEffect, useState, useRef, useMemo } from "react";
import IconButton from "@mui/material/IconButton";
import { Add, Info, Remove, Visibility, VisibilityOff } from "@mui/icons-material";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import InputLabel from "@mui/material/InputLabel";
import ListItemText from "@mui/material/ListItemText";
import Checkbox from "@mui/material/Checkbox";
import Tooltip from "@mui/material/Tooltip";
import Divider from "@mui/material/Divider";
import parse from "html-react-parser";
import { ReactSmartScroller } from "react-smart-scroller";
import AlignVerticalTopIcon from "@mui/icons-material/AlignVerticalTop";
import AlignVerticalCenterIcon from "@mui/icons-material/AlignVerticalCenter";
import InfoIcon from '@mui/icons-material/Info';
import { Typography } from "@mui/material";

function Base(args) {
	const [alignTop, setAlignTop] = useState(true);
	const ElementPan = require("react-element-pan");
	const [showHiddenNodes, setShowHiddenNodes] = useState(true);
	const [marginTop, setMarginTop] = useState("30px");
	const [arrayStyle, setArrayStyle] = useState();
	const [style, setStyle] = useState({
		width: "100%",
	});
	const [buttonStyle, setButtonStyle] = useState({
		width: "200px",
		height: "140px",
		fontSize: "15px",
	});
	const [titleStyle, setTitleStyle] = useState({
		width: "200px",
		fontSize: "25px",
		height: "55px ",
	});

	const [opacity, setOpacity] = useState(
		new Array(Object.keys(args.nodesText).length).fill(1)
	);
	const [visibility, setVisibility] = useState(
		new Array(Object.keys(args.nodesText).length).fill("visible")
	);
	const [nodesDisplayed, setNodesDisplayed] = useState(
		Object.keys(args.nodesText)
	);
	const [active, setActive] = useState({});
	const [color, setColor] = useState(
		new Array(Object.keys(args.nodesText).length).fill({
			backgroundColor: "#e7e7e7",
			color: "black",
		})
	);

	const show = useRef();
	const hide = useRef();
	const nodesText = args.nodesText;
	const filtersCorrespond = args.filtersCorrespond;
	const getDeliveryDates = (text) => {
		switch (text) {
			case "Op FORTITUDE":
				return "Delivery dates: 02/04/2023 - 31/03/2025\nFunding: £499,471";
			case "Riverside - Ending Veteran Homelessness Together":
				return "Delivery dates: 03/07/2023 - 29/06/2025\nFunding: £830,790";
			case "Sustained Support for Homeless Veterans":
				return "Delivery dates: 28/08/2023 - 27/08/2025\nFunding: £859,181";
			case "New Seasons - Veterans Supported Housing":
				return "Delivery dates: 01/09/2023 - 31/08/2025\nFunding:\nYear 1:   £495,000\nYear 2:  £500,000";
			case "Reducing Homelessness for Scottish Veterans":
				return "Delivery dates: 02/10/2023 - 06/10/2025\nFunding:\nYear 1:   £450,560\nYear 2:  £456,511";
			case "Homes at Ease Northwest":
				return "Delivery dates: 01/09/2023 - 31/08/2025\nFunding: £915,636";
			case "STEP-IN - Overcoming Homelessness":
				return "Delivery dates: 01/09/2023-31/03/2025\nFunding: £254,550";
			case "Achieving Independent Living for Veterans":
				return "Delivery dates: 01/09/2023-31/08/2025\nFunding: £232,208";
			case "Alabaré Homes for Veterans":
				return "Delivery dates: 01/07/2023-30/06/2025\nFunding: £975,236\nEnhanced Grant Award: £404,978";
			case "Stoll Veterans Supported Housing":
				return "Delivery dates: 03/07/2023-01/07/2025\nFunding:\nYear 1:   £411,151\nYear 2:  £428,684";
			default:
				return null; // Default empty string if not found
		}
	};
	// const nodes = [
	// 	// 1st column
	// 	[0, [4, 5], []],
	// 	[1, [4, 5], []],
	// 	[2, [5], []],
	// 	[3, [5], []],
	// 	//2nd column
	// 	[4, [6], [0, 1]],
	// 	[5, [7], [0, 1, 2, 3]],
	// 	//3rd column
	// 	[6, [8], [4]],
	// 	[7, [9], [5]],
	// 	//4th column
	// 	[8, [10], [6]],
	// 	[9, [10], [7]],
	// 	//5th column
	// 	[10, [11, 12], [8, 9]],
	// 	//6th column
	// 	[11, [], [10]],
	// 	[12, [], [10]],
	// ];

	const [nodes, setNodes] = useState();
	const filterNames = args.filterNames;
	const paths = args.paths;
	const columnsSelectedInitial = args.columns;

	const columns = args.columns;
	const [filters, setFilters] = useState(args.filters);
	const filtersInitial = args.filters;
	const filtersNodes = args.filtersNodes;
	const columnsNodes = args.columnsNodes;
	const [columnsSelected, setColumnsSelected] = useState(args.columns);
	const [isCheckAllColumns, setIsCheckAllColumns] = useState(true);
	const [inputNodesFilter, setInputNodesFilter] = useState({});

	const [nodesFilter, setNodesFilter] = useState();

	const [nodesShow, setNodesShow] = useState(() => {
		let array = [];
		for (let i = 0; i <= Object.keys(args.nodesText).length; i++) {
			array.push(i);
		}
		return array;
	});

	const [isCheckAll, setIsCheckAll] = useState(
		new Array(args.filterNames.length).fill(true)
	);

	const [checked, setChecked] = useState(false);

	useEffect(() => {
		let flag = false;
		color.forEach((element) => {
			if (element["color"] === "white") {
				flag = true;
				return;
			}
		});
		setChecked(flag); // eslint-disable-next-line react-hooks/exhaustive-deps
	}, color);

	// in order the footer to not be hided by the floating tools
	window.addEventListener("scroll", () => {
		const elem = document.querySelector(".floating-tools");
		if (elem !== null) {
			if (
				window.innerHeight + window.scrollY >=
				document.body.offsetHeight - 100
			) {
				elem.style.marginBottom = "150px";
			} else {
				elem.style.marginBottom = "25px";
			}
		}
	});

	useEffect(() => {
		clear(); // eslint-disable-next-line react-hooks/exhaustive-deps
	}, [columnsSelected]);

	const handleChangeFilter = (e, index) => {
		e.preventDefault();
		let isCheckAllTemp = [...isCheckAll];
		setChecked(false);
		setActive({});
		let filtersTemp = [...filters];
		if (e.target.value.includes("Select All")) {
			if (isCheckAllTemp[index] === true) {
				filtersTemp[index] = [];
				isCheckAllTemp[index] = false;
			} else {
				filtersTemp[index] = filtersInitial[index];
				isCheckAllTemp[index] = true;
			}
		} else {
			isCheckAllTemp[index] = false;
			filtersTemp[index] = e.target.value;
		}
		setIsCheckAll(isCheckAllTemp);

		setFilters(filtersTemp);
		setVisibility(
			new Array(Object.keys(args.nodesText).length).fill("visible")
		);
		setOpacity(new Array(Object.keys(args.nodesText).length).fill(1));
		let colorTemp = new Array(Object.keys(args.nodesText).length).fill({
			backgroundColor: "#e7e7e7",
			color: "black",
		});
		setColor(colorTemp);
		let arrayStyleTemp = [...arrayStyle];
		nodes.forEach((node) => {
			node[1].forEach((nodeLeft) => {
				arrayStyleTemp[node[0]][nodeLeft] = {
					strokeColor: "var(--stroke-color)",
					strokeWidth: "3",
					strokeDasharray: "none",
					endMarker: false,
				};
			});
		});
		setArrayStyle(arrayStyleTemp);
		let nodesIntermediate = JSON.parse(JSON.stringify(nodes));
		// let targetGroupPaths = [];
		// filtersTemp[0].forEach((targetGroupCategory) => {
		// 	targetGroupPaths.push(...filtersNodes[0][targetGroupCategory]);
		// });
		// let nodesPath = [];
		// for (let i = 0; i < Object.keys(args.nodesText).length; i++) {
		// 	nodesPath.push([i, [], []]);
		// }
		// targetGroupPaths.forEach((path) => {
		// 	for (let j = 0; j < path.length - 1; j++) {
		// 		for (let i = j + 1; i < path.length; i++) {
		// 			if (!nodesPath[path[j]][1].includes(path[i])) {
		// 				nodesPath[path[j]][1].push(path[i]);
		// 				nodesPath[path[i]][2].push(path[j]);
		// 			}
		// 			break;
		// 		}
		// 	}
		// });

		// for (let i = 0; i < nodesPath.length; i++) {
		// 	nodesIntermediate[i][1] = nodesIntermediate[i][1].filter((x) =>
		// 		nodesPath[i][1].includes(x)
		// 	);
		// 	nodesIntermediate[i][2] = nodesIntermediate[i][2].filter((x) =>
		// 		nodesPath[i][2].includes(x)
		// 	);
		// }
		let nodesShowTemp = Array(Object.keys(args.nodesText).length)
			.fill(null)
			.map((item, index) => index);

		for (let j = 0; j < filtersTemp.length; j++) {
			if (
				columnsSelected.includes(
					filtersCorrespond[filterNames[j]].toString()
				)
			) {
				let categoryNodes = [];
				filtersTemp[j].forEach((category) => {
					filtersNodes[j][category].forEach((element) => {
						if (nodesShowTemp.includes(element)) {
							if (!categoryNodes.includes(element)) {
								categoryNodes.push(element);
							}
						}
					});
				});
				let elementsToCheckRight = categoryNodes;
				let elementsToCheckLeft = categoryNodes;
				while (true) {
					let newAddRight = [];
					elementsToCheckRight.forEach((node) => {
						let elements = nodesIntermediate[node][1];
						elements.forEach((element) => {
							if (!newAddRight.includes(element)) {
								newAddRight.push(element);
							}
						});
					});
					elementsToCheckRight = newAddRight;

					let newAddLeft = [];
					elementsToCheckLeft.forEach((element) => {
						for (let i = 0; i < nodesIntermediate.length; i++) {
							if (nodesIntermediate[i][1].includes(element)) {
								if (
									!newAddLeft.includes(
										nodesIntermediate[i][0]
									)
								) {
									newAddLeft.push(nodesIntermediate[i][0]);
								}
							}
						}
					});
					elementsToCheckLeft = newAddLeft;
					categoryNodes = [
						...categoryNodes,
						...newAddLeft,
						...newAddRight,
					];

					if (
						elementsToCheckLeft.length === 0 &&
						elementsToCheckRight.length === 0
					) {
						break;
					}
				}

				let nodesFilterTemp = [];
				for (let i = 0; i <= nodesIntermediate.length; i++) {
					if (categoryNodes.includes(i)) {
						nodesFilterTemp.push([nodesIntermediate[i][0], [], []]);
						nodesIntermediate[i][1].forEach((element) => {
							if (categoryNodes.includes(element)) {
								nodesFilterTemp[
									nodesFilterTemp.length - 1
								][1].push(element);
							}
						});
						nodesIntermediate[i][2].forEach((element) => {
							if (categoryNodes.includes(element)) {
								nodesFilterTemp[
									nodesFilterTemp.length - 1
								][2].push(element);
							}
						});
					} else {
						nodesFilterTemp.push([[], [], []]);
					}
				}
				nodesIntermediate = nodesFilterTemp;
				nodesShowTemp = categoryNodes;
			}
		}

		setNodesFilter(nodesIntermediate);
		setNodesShow(nodesShowTemp);
	};

	const zoomInAction = (e) => {
		e.preventDefault();
		let width = style["width"].split("v")[0];
		width = Math.round(parseInt(width) * 1.1);
		if (parseInt(width) < 300) {
			width = width.toString() + "vw";
			let arrayStyleTemp = arrayStyle;
			for (let i = 0; i < arrayStyleTemp.length; i++) {
				Object.keys(arrayStyleTemp[i]).forEach((node) => {
					arrayStyleTemp[i][node]["strokeWidth"] = (
						1.1 * parseFloat(arrayStyleTemp[i][node]["strokeWidth"])
					).toString();
				});
			}
			let marginTopTemp =
				Math.round(parseInt(marginTop.split("p")[0]) * 1.1).toString() +
				"px";
			let buttonStyleTemp = {
				width:
					Math.round(
						parseInt(buttonStyle["width"].split("p")[0]) * 1.1
					).toString() + "px",
				height:
					Math.round(
						parseInt(buttonStyle["height"].split("p")[0]) * 1.1
					).toString() + "px",
				fontSize:
					Math.round(
						parseInt(buttonStyle["fontSize"].split("p")[0]) * 1.1
					).toString() + "px",
			};

			let titleStyleTemp = {
				width:
					Math.round(parseInt(titleStyle["width"]) * 1.1).toString() +
					"px",
				height:
					Math.round(
						parseInt(titleStyle["height"]) * 1.1
					).toString() + "px",
				fontSize:
					Math.round(
						parseInt(titleStyle["fontSize"]) * 1.1
					).toString() + "px",
			};

			setButtonStyle(buttonStyleTemp);
			setTitleStyle(titleStyleTemp);
			setMarginTop(marginTopTemp);
			setArrayStyle(arrayStyleTemp);
			setStyle({ width: width });
		}
	};
	const zoomOutAction = (e) => {
		e.preventDefault();
		let width = style["width"].split("v")[0];
		if (parseInt(width) > 100) {
			width = Math.round(parseInt(width) / 1.1);
			width = width.toString() + "vw";
			if (width === "100vw") {
				width = "100%";
			}
			let arrayStyleTemp = arrayStyle;
			for (let i = 0; i < arrayStyleTemp.length; i++) {
				Object.keys(arrayStyleTemp[i]).forEach((node) => {
					arrayStyleTemp[i][node]["strokeWidth"] = (
						parseFloat(arrayStyleTemp[i][node]["strokeWidth"]) / 1.1
					).toString();
				});
			}

			let marginTopTemp =
				(parseInt(marginTop.split("p")[0]) / 1.1).toString() + "px";
			let buttonStyleTemp = {
				width:
					Math.round(
						parseInt(buttonStyle["width"].split("p")[0]) / 1.1
					).toString() + "px",
				height:
					Math.round(
						parseInt(buttonStyle["height"].split("p")[0]) / 1.1
					).toString() + "px",
				fontSize:
					Math.round(
						parseInt(buttonStyle["fontSize"].split("p")[0]) / 1.1
					).toString() + "px",
			};
			let titleStyleTemp = {
				width:
					Math.round(parseInt(titleStyle["width"]) / 1.1).toString() +
					"px",
				height:
					Math.round(
						parseInt(titleStyle["height"]) / 1.1
					).toString() + "px",
				fontSize:
					Math.round(
						parseInt(titleStyle["fontSize"]) / 1.1
					).toString() + "px",
			};
			setButtonStyle(buttonStyleTemp);
			setTitleStyle(titleStyleTemp);
			setMarginTop(marginTopTemp);
			setArrayStyle(arrayStyleTemp);
			setStyle({ width: width });
		}
	};

	const originatesFromSingleInput = useMemo(() => {
		return (elementClicked) => {
			const set = new Set(Object.keys(inputNodesFilter));
			let elementLeft = nodesFilter[elementClicked][2];
			while(elementLeft.length===1){
				const node = elementLeft[0];
				if(set.has(String(node))){
					return node;
				}
				elementLeft = nodesFilter[node][2];
			}
			return -1;
		};
	}, [inputNodesFilter, nodesFilter]);

	const handleChoose = (e, elementClicked) => {
		let selectedNodesFilter = {}
		const singleOrigin = originatesFromSingleInput(elementClicked);
		if(inputNodesFilter[elementClicked]!==undefined){
			selectedNodesFilter = inputNodesFilter[elementClicked];
		}else if(singleOrigin!==-1){
			selectedNodesFilter = inputNodesFilter[singleOrigin];
		}else{
			selectedNodesFilter = nodesFilter
		}
		e.preventDefault();
		let foundElements = {};
		let activeTemp = JSON.parse(JSON.stringify(active));
		if (!Object.keys(activeTemp).includes(elementClicked.toString())) {
			let elementsToCheckRight = selectedNodesFilter[elementClicked][1];
			let elementsToCheckLeft = [elementClicked];
			foundElements[elementClicked] = elementsToCheckRight;
			while (true) {
				let newAddRight = [];
				elementsToCheckRight.forEach((element) => {
					selectedNodesFilter[element][1].forEach((node) => {
						let isFound = Object.keys(foundElements).some(
							(foundElement) => {
								if (foundElement === node) {
									return true;
								}
								return false;
							}
						);
						if (!isFound) {
							newAddRight.push(...selectedNodesFilter[element][1]);
						}
					});
					foundElements[element] = selectedNodesFilter[element][1];
				});
				elementsToCheckRight = newAddRight;

				let newAddLeft = [];
				elementsToCheckLeft.forEach((element) => {
					selectedNodesFilter[element][2].forEach((nodeLeft) => {
						newAddLeft.push(nodeLeft);
						let isFound = Object.keys(foundElements).includes(
							nodeLeft.toString()
						);
						if (isFound) {
							foundElements[nodeLeft].push(element);
						} else {
							foundElements[nodeLeft] = [element];
						}
					});
				});
				elementsToCheckLeft = newAddLeft;

				if (
					elementsToCheckRight.length === 0 &&
					elementsToCheckLeft.length === 0
				) {
					break;
				}
			}
			activeTemp[elementClicked] = foundElements;
		} else {
			delete activeTemp[elementClicked];
		}
		let arrayStyleTemp = [...arrayStyle];
		let visibilityTemp;
		let opacityTemp;
		let colorTemp = new Array(Object.keys(args.nodesText).length).fill({
			backgroundColor: "#e7e7e7",
			color: "black",
		});
		if (Object.keys(activeTemp).length > 0) {
			if (!showHiddenNodes) {
				visibilityTemp = new Array(
					Object.keys(args.nodesText).length
				).fill("hidden");
				opacityTemp = visibilityTemp = new Array(
					Object.keys(args.nodesText).length
				).fill(1);
			} else {
				opacityTemp = visibilityTemp = new Array(
					Object.keys(args.nodesText).length
				).fill(0.5);
				visibilityTemp = new Array(
					Object.keys(args.nodesText).length
				).fill("visible");
			}
			Object.keys(arrayStyleTemp).forEach((key) => {
				Object.keys(arrayStyleTemp[key]).forEach((element) => {
					arrayStyleTemp[key][element]["strokeColor"] = "transparent";
				});
			});
			let nodesDisplayedTemp = [];
			Object.keys(activeTemp).forEach((activeElement) => {
				colorTemp[activeElement] = {
					backgroundColor: "#008CBA",
					color: "white",
					border: "3px solid var(--stroke-color)",
					boxShadow: "rgba(149, 157, 165, 0.2) 0px 8px 24px",
				};
				foundElements = activeTemp[activeElement];
				Object.keys(foundElements).forEach((key) => {
					if (!nodesDisplayedTemp.includes(parseInt(key))) {
						nodesDisplayedTemp.push(parseInt(key));
						opacityTemp[parseInt(key)] = 1;
					}
					visibilityTemp[key] = "visible";
					foundElements[key].forEach((element) => {
						if (!nodesDisplayedTemp.includes(element)) {
							nodesDisplayedTemp.push(element);
							opacityTemp[element] = 1;
						}

						arrayStyleTemp[key][element]["strokeColor"] =
							"var(--stroke-color)";
					});
				});
			});
			setNodesDisplayed(nodesDisplayedTemp);
		} else {
			setNodesDisplayed(Object.keys(args.nodesText));
			visibilityTemp = new Array(Object.keys(args.nodesText).length).fill(
				"visible"
			);
			opacityTemp = new Array(Object.keys(args.nodesText).length).fill(1);
			nodesFilter.forEach((node) => {
				node[1].forEach((nodeLeft) => {
					arrayStyleTemp[node[0]][nodeLeft]["strokeColor"] =
						"var(--stroke-color)";
				});
			});
		}
		setColor(colorTemp);
		setActive(activeTemp);
		setVisibility(visibilityTemp);
		setOpacity(opacityTemp);
		setArrayStyle(arrayStyleTemp);
	};

	const handleClear = (e) => {
		e.preventDefault();
		setColumnsSelected([...columns]);
		args.setPillarsChosen(args.pillarChoices);
		args.setIsCheckAll(true);
	};

	function clear() {
		setIsCheckAll(new Array(isCheckAll.length).fill(true));
		setNodesDisplayed(Object.keys(args.nodesText));
		setChecked(false);
		setVisibility(
			new Array(Object.keys(args.nodesText).length).fill("visible")
		);
		setOpacity(new Array(Object.keys(args.nodesText).length).fill(1));
		setColor(
			new Array(Object.keys(args.nodesText).length).fill({
				backgroundColor: "#e7e7e7",
				color: "black",
			})
		);
		let selectedNodes = [];
		columnsSelected.forEach((column) => {
			selectedNodes = [...selectedNodes, ...columnsNodes[column]];
		});

		if(Object.keys(inputNodesFilter).length===0){
			const inputPathMapTmp = {}
			Object.keys(args.tocData.toc).forEach((key,i)=>{
				inputPathMapTmp[i]=generateNotesFromPaths(args.tocData.toc[key].paths,selectedNodes)[0]
			})
			setInputNodesFilter(inputPathMapTmp)
		}

		const [nodesTemp, arrayStyleTemp] = generateNotesFromPaths(paths,selectedNodes)

		setFilters(filtersInitial);
		setNodesShow(selectedNodes);
		setNodes(nodesTemp);
		setNodesFilter(nodesTemp);
		setActive({});
		setArrayStyle(arrayStyleTemp);
	}

	function generateNotesFromPaths(paths, selectedNodes){
		let arrayStyleTemp = [];
		let nodesTemp = [];
		for (let i = 0; i < Object.keys(args.nodesText).length; i++) {
			arrayStyleTemp.push({});
			nodesTemp.push([i, [], []]);
		}
		paths.forEach((path) => {
			try{
				for (let j = 0; j < path.length - 1; j++) {
					for (let i = j + 1; i < path.length; i++) {
						if (selectedNodes.includes(path[i])) {
							arrayStyleTemp[path[j]][path[i]] = {
								strokeColor: "var(--stroke-color)",
								strokeWidth: "3",
								strokeDasharray: "none",
								endMarker: false,
							};
							if (!nodesTemp[path[j]][1].includes(path[i])) {
								nodesTemp[path[j]][1].push(path[i]);
								nodesTemp[path[i]][2].push(path[j]);
							}
							break;
						}
					}
				}
			}catch(e){
				console.error(e)
			}
		});
		return [nodesTemp, arrayStyleTemp]
	}

	const handleChangeColumns = (e) => {
		e.preventDefault();
		if (e.target.value.includes("Select All")) {
			if (isCheckAllColumns) {
				setColumnsSelected([]);
				setIsCheckAllColumns(false);
			} else {
				setColumnsSelected(columnsSelectedInitial);
				setIsCheckAllColumns(true);
			}
		} else {
			setIsCheckAllColumns(false);

			setColumnsSelected(e.target.value);
		}
	};

	const handleShowHiddenNodes = (e) => {
		e.preventDefault();
		if (showHiddenNodes) {
			let visibilityTemp = new Array(visibility.length).fill("hidden");
			nodesDisplayed.forEach((node) => {
				visibilityTemp[node] = "visible";
			});
			setVisibility(visibilityTemp);
			setOpacity(new Array(opacity.length).fill(1));
		} else {
			let opacityTemp = new Array(opacity.length).fill(0.5);
			nodesDisplayed.forEach((node) => {
				opacityTemp[node] = 1;
			});
			setOpacity(opacityTemp);
			setVisibility(new Array(visibility.length).fill("visible"));
		}
		setShowHiddenNodes(!showHiddenNodes);
	};

	const handleChangeAlign = (e) => {
		e.preventDefault();
		setAlignTop(!alignTop);
		let button;

		button =
			typeof show.current !== "undefined" && show.current !== null
				? show
				: hide;
		button.current.dispatchEvent(
			new MouseEvent("click", {
				view: window,
				bubbles: true,
				cancelable: true,
				buttons: 1,
			})
		);

		setTimeout(() => {
			button =
				typeof show.current !== "undefined" && show.current !== null
					? show
					: hide;
			button.current.dispatchEvent(
				new MouseEvent("click", {
					view: window,
					bubbles: true,
					cancelable: true,
					buttons: 1,
				})
			);
		}, 3);
	};

	return (
		<div>
			<div className="top-container" style={{ paddingTop: "0px" }}>
				<div className="filters-container">
					<div className="selects-container">
						{filters.map((filter, index) => {
							return (
								typeof columnsSelected !== "undefined" &&
								typeof filtersCorrespond !== "undefined" &&
								!filterNames[index]
									.toLowerCase()
									.includes(
										"programme (filter)"
									) && (
									<FormControl
										className="secondary-filter"
										variant="filled"
										size="small"
										disabled={
											!columnsSelected.includes(
												filtersCorrespond[
													filterNames[index]
												]
											) ||
											(Object.keys(filtersNodes[index])
												.length === 1 &&
												Object.keys(
													filtersNodes[index]
												)[0].length === 0)
										}
										key={filterNames[index]}
									>
										<InputLabel className="label">
											{filterNames[index].replace(
												" (filter)",
												""
											)}
										</InputLabel>
										<Select
											labelId={
												"filter-" +
												filterNames[index] +
												"-multiple-checkbox-label"
											}
											id={
												"filter-" +
												filterNames[index] +
												"-multiple-checkbox"
											}
											multiple
											value={filters[index]}
											onChange={(event) =>
												handleChangeFilter(event, index)
											}
											renderValue={(selected) => {
												selected = selected.filter(
													(n) => n
												);
												return selected.join(", ");
											}}
											sx={{
												color: "var(--primary-color)",
												".MuiSvgIcon-root ": {
													fill: "var(--primary-color) !important",
												},
												"&:before": {
													border: "none",
												},
												"&:after": {
													border: "none",
												},
												"&:not(.Mui-disabled):hover::before":
													{
														border: "none",
													},
											}}
										>
											{filterNames[index].length > 0 && (
												<MenuItem
													key="Select All"
													value="Select All"
												>
													<Checkbox
														checked={
															isCheckAll[index]
														}
													/>
													<ListItemText primary="Select All" />
												</MenuItem>
											)}
											{Object.keys(
												filtersNodes[index]
											).map((filterChoice) => {
												if (filterChoice !== "") {
													return (
														<MenuItem
															key={filterChoice}
															value={filterChoice}
														>
															<Checkbox
																checked={
																	filters[
																		index
																	].indexOf(
																		filterChoice
																	) > -1
																}
															/>
															<ListItemText
																primary={
																	filterChoice
																}
															/>
														</MenuItem>
													);
												}
												return <></>;
											})}
										</Select>
									</FormControl>
								)
							);
						})}

						<FormControl
							className="secondary-filter"
							id="filter-columns-multiple-checkbox-container"
							variant="filled"
							size="small"
						>
							<InputLabel className="label">Columns</InputLabel>
							<Select
								labelId="filter-columns-multiple-checkbox-label"
								id="filter-columns-multiple-checkbox"
								multiple
								value={columnsSelected}
								onChange={handleChangeColumns}
								renderValue={(selected) => {
									selected = selected.filter((n) => n);
									return selected.join(", ");
								}}
								sx={{
									color: "var(--primary-color)",
									".MuiSvgIcon-root ": {
										fill: "white !important",
									},
									"&:before": {
										border: "none",
									},
									"&:after": {
										border: "none",
									},
									"&:not(.Mui-disabled):hover::before": {
										border: "none",
									},
								}}
							>
								<MenuItem key="Select All" value="Select All">
									<Checkbox checked={isCheckAllColumns} />
									<ListItemText primary="Select All" />
								</MenuItem>
								{columns.map((column) => (
									<MenuItem key={column} value={column}>
										<Checkbox
											checked={
												columnsSelected.indexOf(
													column
												) > -1
											}
										/>
										<ListItemText primary={column} />
									</MenuItem>
								))}
							</Select>
						</FormControl>
						<div className="clear-button-container">
							<button onClick={(event) => handleClear(event)}>
								Clear Filters
							</button>
						</div>

						<div className="invisible-button-container" />
						<div className="invisible-button-container" />
						<div className="invisible-button-container" />
						<div className="invisible-button-container" />
						<div className="invisible-button-container" />
					</div>
					{/* <div className="button-container">
						<button onClick={(event) => handleClear(event)}>
							Clear
						</button>
					</div> */}
				</div>
			</div>
			<div className="floating-tools">
				{/* <FormControlLabel
					control={
						<Switch
							checked={showHiddenNodes}
							onChange={(event) => handleShowHiddenNodes(event)}
							name="showhiddenNodes"
							size="small"
						/>
					}
					label="Show hidden nodes"
				/> */}
				{alignTop ? (
					<Tooltip title="Align nodes in the center">
						<IconButton
							aria-label="align-top-center"
							fontSize="large"
							onClick={(event) => handleChangeAlign(event)}
						>
							<AlignVerticalCenterIcon fontSize="small" />
						</IconButton>
					</Tooltip>
				) : (
					<Tooltip title="Align nodes at the top">
						<IconButton
							aria-label="align-top-center"
							fontSize="large"
							onClick={(event) => handleChangeAlign(event)}
						>
							<AlignVerticalTopIcon fontSize="small" />
						</IconButton>
					</Tooltip>
				)}
				{showHiddenNodes ? (
					<Tooltip title="Hide hidden nodes">
						<IconButton
							ref={hide}
							aria-label="show-hidden-nodes"
							fontSize="large"
							onClick={(event) => handleShowHiddenNodes(event)}
						>
							<VisibilityOff fontSize="small" />
						</IconButton>
					</Tooltip>
				) : (
					<Tooltip title="Show hidden nodes">
						<IconButton
							ref={show}
							aria-label="show-hidden-nodes"
							fontSize="large"
							onClick={(event) => handleShowHiddenNodes(event)}
						>
							<Visibility fontSize="small" />
						</IconButton>
					</Tooltip>
				)}
				<Divider orientation="vertical" variant="middle" flexItem />
				<Tooltip title="Zoom out">
					<IconButton
						aria-label="zoom-out"
						fontSize="large"
						onClick={(event) => zoomOutAction(event)}
					>
						<Remove fontSize="small" />
					</IconButton>
				</Tooltip>
				<Tooltip title="Zoom in">
					<IconButton
						aria-label="zoom-in"
						fontSize="large"
						onClick={(event) => zoomInAction(event)}
					>
						<Add fontSize="small" />
					</IconButton>
				</Tooltip>
			</div>
			<ReactSmartScroller draggable>
				<div className="toc-container">
					{parseInt(style["width"].split("v")[0]) > 100 ? (
						<ElementPan height={window.innerHeight}>
							<div style={style} className="toc-subcontainer">
								{arrayStyle && (
									<ArcherContainer strokeColor="var(--stroke-color)">
										<div
											style={{
												display: "flex",
												gridTemplateColumns:
													"repeat(" +
													columnsSelected.length +
													", 1fr)",
												justifyContent: "space-between",
											}}
										>
											{columns.map((column, index) => {
												const outcomeIndex =
													column.indexOf(
														"Outcomes"
													) &&
													column.indexOf("Impacts");
												let beforeOutcome = null;
												let afterOutcome = null;

												if (outcomeIndex !== -1) {
													beforeOutcome =
														column.substring(
															0,
															outcomeIndex +
																"Outcomes"
																	.length
														);
													afterOutcome =
														column.substring(
															outcomeIndex +
																"Outcomes"
																	.length
														);
												}
												return (
													index <
														columns.length - 1 &&
													columnsSelected.includes(
														column
													) && (
														<div className="toc-column">
															<div
																style={
																	titleStyle
																}
																className="toc-column-title"
															>
																{beforeOutcome &&
																afterOutcome ? (
																	<>
																		<span
																			style={
																				titleStyle
																			}
																		>
																			{
																				beforeOutcome
																			}
																		</span>
																		<br></br>

																		<span
																			style={{
																				display:
																					"flex",
																				alignItems:
																					"center",
																				justifyContent:
																					"center",
																				fontSize:
																					"10px",
																			}}
																		>
																			{
																				afterOutcome
																			}
																		</span>
																	</>
																) : (
																	<>
																		<div
																			style={
																				titleStyle
																			}
																		>
																			{
																				column
																			}
																		</div>
																	</>
																)}
															</div>
															<div
																style={{
																	height: "100%",
																	display:
																		"flex",
																	// padding:
																	// 	"50px 20px 50px 20px",
																	flexDirection:
																		"column",

																	justifyContent:
																		alignTop
																			? "flex-start"
																			: "space-evenly",
																}}
															>
																{columnsNodes[
																	column
																].map((i) => {
																	if (
																		nodesShow.includes(
																			i
																		)
																	) {
																		return (
																			<div
																				style={{
																					marginTop:
																						visibility[
																							i
																						] ===
																						"visible"
																							? marginTop
																							: "0px",
																				}}
																			>
																				{
																					visibility[
																						i
																					] ===
																						"visible" && (
																						<ArcherElement
																							id={i.toString()}
																							relations={nodesFilter[
																								i
																							][1].map(
																								(
																									node
																								) =>
																									(arrayStyle[
																										i
																									][
																										node
																									][
																										"strokeColor"
																									] ===
																										"var(--stroke-color)" ||
																										checked ===
																											false) && {
																										targetId:
																											node,
																										targetAnchor:
																											"left",
																										sourceAnchor:
																											"right",
																										style: arrayStyle[
																											i
																										][
																											node
																										],
																									}
																							)}
																						>
																							<div
																								style={{
																									width: buttonStyle[
																										"width"
																									],
																									height: buttonStyle[
																										"height"
																									],
																									visibility:
																										visibility[
																											i
																										],
																								}}
																								className={
																									"toc-node-container"
																								}
																							>
																								{index ===
																								0 ? (
																									<Tooltip
																										title={
																											<div
																												style={{
																													whiteSpace:
																														"pre-line",
																													fontSize:
																														"15px",
																												}}
																											>
																												{getDeliveryDates(
																													nodesText[
																														i
																													][0]
																												)}
																											</div>
																										}
																										arrow
																									>
																										<button
																											style={{
																												...buttonStyle,
																												...color[
																													i
																												],
																												opacity:
																													opacity[
																														i
																													],
																											}}
																											id={i.toString()}
																											className={
																												"toc-node toc-node-col" +
																												index.toString()
																											}
																											onClick={(
																												event
																											) => {
																												handleChoose(
																													event,
																													i
																												);
																											}}
																										>
																											{
																												nodesText[
																													i
																												][0]
																											}
																										</button>
																									</Tooltip>
																								) : (
																									<button
																										style={{
																											...buttonStyle,
																											...color[
																												i
																											],
																											opacity:
																												opacity[
																													i
																												],
																										}}
																										id={i.toString()}
																										className={
																											"toc-node toc-node-col" +
																											index.toString()
																										}
																										onClick={(
																											event
																										) => {
																											handleChoose(
																												event,
																												i
																											);
																										}}
																									>
																										{
																											nodesText[
																												i
																											][0]
																										}
																									</button>
																								)}
																							</div>
																						</ArcherElement>
																					)
																					// 	: (
																					// 	<div
																					// 		style={{
																					// 			width: buttonStyle[
																					// 				"width"
																					// 			],
																					// 			height: buttonStyle[
																					// 				"height"
																					// 			],
																					// 			visibility:
																					// 				visibility[
																					// 					i
																					// 				],
																					// 		}}
																					// 	>
																					// 		<button
																					// 			style={{
																					// 				...buttonStyle,
																					// 				...color[
																					// 					i
																					// 				],
																					// 			}}
																					// 			className={i.toString()}
																					// 			// variant={
																					// 			// 	contained[
																					// 			// 		i
																					// 			// 	]
																					// 			// }
																					// 			onClick={(
																					// 				event
																					// 			) =>
																					// 				handleChoose(
																					// 					event,
																					// 					i
																					// 				)
																					// 			}
																					// 		>
																					// 			{
																					// 				nodesText[
																					// 					i
																					// 				]
																					// 			}
																					// 		</button>
																					// 	</div>
																					// )
																				}
																			</div>
																		);
																	}
																	return (
																		<></>
																	);
																})}
															</div>
														</div>
													)
												);
											})}
											{columnsSelected.includes(
												columns[columns.length - 1]
											) && (
												<div className="toc-column">
													<div
														style={titleStyle}
														className="toc-column-title"
													>
														<div style={titleStyle}>
															{
																columns[
																	columns.length -
																		1
																]
															}
														</div>
														<br />
													</div>
													<div
														style={{
															height: "100%",
															display: "flex",
															// padding:
															// 	"50px 20px 50px 20px",
															flexDirection:
																"column",

															justifyContent:
																alignTop
																	? "flex-start"
																	: "space-evenly",
														}}
													>
														{columnsNodes[
															columns[
																columns.length -
																	1
															]
														].map((i) => {
															if (
																nodesShow.includes(
																	i
																)
															) {
																return (
																	<div
																		style={{
																			marginTop:
																				marginTop,
																		}}
																	>
																		{visibility[
																			i
																		] ===
																			"visible" && (
																			<ArcherElement
																				id={i.toString()}
																				relations={nodesFilter[
																					i
																				][1].map(
																					(
																						node
																					) =>
																						(arrayStyle[
																							i
																						][
																							node
																						][
																							"strokeColor"
																						] ===
																							"var(--stroke-color)" ||
																							checked ===
																								false) && {
																							targetId:
																								node,
																							targetAnchor:
																								"left",
																							sourceAnchor:
																								"right",
																							style: arrayStyle[
																								i
																							][
																								node
																							],
																						}
																				)}
																			>
																				<div
																					style={{
																						width: buttonStyle[
																							"width"
																						],
																						height: buttonStyle[
																							"height"
																						],
																						visibility:
																							visibility[
																								i
																							],
																					}}
																					className="toc-node-container"
																				>
																					<button
																						// disabled={
																						// 	disabled[
																						// 		i
																						// 	]
																						// }
																						style={{
																							...buttonStyle,
																							...color[
																								i
																							],
																							opacity:
																								opacity[
																									i
																								],
																						}}
																						id={i.toString()}
																						className="toc-node toc-node-last"
																						onClick={(
																							event
																						) =>
																							handleChoose(
																								event,
																								i
																							)
																						}
																					>
																						{parse(
																							nodesText[
																								i
																							][0]
																						)}
																					</button>
																				</div>
																			</ArcherElement>
																		)}
																	</div>
																);
															}
															return <></>;
														})}
													</div>
												</div>
											)}
										</div>
									</ArcherContainer>
								)}
							</div>
						</ElementPan>
					) : (
						<div style={style} className="toc-subcontainer">
							{arrayStyle && (
								<ArcherContainer strokeColor="var(--stroke-color)">
									<div
										style={{
											display: "flex",
											gridTemplateColumns:
												"repeat(" +
												columnsSelected.length +
												", 1fr)",
											justifyContent: "space-between",
										}}
									>
										{columns.map((column, index) => {
											const outcomeIndex =
												column.indexOf("Outcomes") &&
												column.indexOf("Impacts");
											let beforeOutcome = null;
											let afterOutcome = null;

											if (outcomeIndex !== -1) {
												beforeOutcome =
													column.substring(
														0,
														outcomeIndex +
															"Outcomes".length
													);
												afterOutcome = column.substring(
													outcomeIndex +
														"Outcomes".length
												);
											}
											return (
												index < columns.length - 1 &&
												columnsSelected.includes(
													column
												) && (
													<div className="toc-column">
														<div
															style={titleStyle}
															className="toc-column-title"
														>
															{beforeOutcome &&
															afterOutcome ? (
																<>
																	<span
																		style={
																			titleStyle
																		}
																	>
																		{
																			beforeOutcome
																		}
																	</span>
																	<br></br>

																	<span
																		style={{
																			display:
																				"flex",
																			alignItems:
																				"center",
																			justifyContent:
																				"center",
																			fontSize:
																				"10px",
																		}}
																	>
																		{
																			afterOutcome
																		}
																	</span>
																</>
															) : (
																<>
																	<div
																		style={
																			{...titleStyle,
																				whiteSpace:
																					"nowrap",
																			}
																		}
																	>
																		<div style={{display: "flex", alignItems: "center", justifyContent: "center"}}>
																			{column}
																		</div>
																	</div>
																</>
															)}
														</div>
														<div
															style={{
																height: "100%",
																display: "flex",
																// padding:
																// 	"50px 20px 50px 20px",
																flexDirection:
																	"column",

																justifyContent:
																	alignTop
																		? "flex-start"
																		: "space-evenly",
															}}
														>
															{columnsNodes[
																column
															].map((i) => {
																if (
																	nodesShow.includes(
																		i
																	)
																) {
																	return (
																		<div
																			style={{
																				display:
																					visibility[
																						i
																					] ===
																					"visible"
																						? "block"
																						: "none",
																				marginTop:
																					visibility[
																						i
																					] ===
																					"visible"
																						? marginTop
																						: "0px",
																			}}
																		>
																			{
																				visibility[
																					i
																				] ===
																					"visible" && (
																					<ArcherElement
																						id={i.toString()}
																						relations={nodesFilter[
																							i
																						][1].map(
																							(
																								node
																							) =>
																								(arrayStyle[
																									i
																								][
																									node
																								][
																									"strokeColor"
																								] ===
																									"var(--stroke-color)" ||
																									checked ===
																										false) && {
																									targetId:
																										node,
																									targetAnchor:
																										"left",
																									sourceAnchor:
																										"right",
																									style: arrayStyle[
																										i
																									][
																										node
																									],
																								}
																						)}
																					>
																						<div
																							style={{
																								width: buttonStyle[
																									"width"
																								],
																								height: buttonStyle[
																									"height"
																								],
																								visibility:
																									visibility[
																										i
																									],
																							}}
																							className={
																								"toc-node-container"
																							}
																						>
																							{index ===
																							0 ? (
																								<button
																									style={{
																										...buttonStyle,
																										...color[
																											i
																										],
																										opacity:
																											opacity[
																												i
																											],
																									}}
																									id={i.toString()}
																									className={
																										"toc-node toc-node-col" +
																										index.toString()
																									}
																									onClick={(
																										event
																									) => {
																										handleChoose(
																											event,
																											i
																										);
																									}}
																								>
																									{
																										nodesText[
																											i
																										][0]
																									}
																								</button>
																							) : (
																								<button
																									style={{
																										...buttonStyle,
																										...color[
																											i
																										],
																										opacity:
																											opacity[
																												i
																											],
																									}}
																									id={i.toString()}
																									className={
																										"toc-node toc-node-col" +
																										index.toString()
																									}
																									onClick={(
																										event
																									) => {
																										handleChoose(
																											event,
																											i
																										);
																									}}
																								>
																									{
																										nodesText[
																											i
																										][0]
																									}
																								</button>
																							)}
																						</div>
																					</ArcherElement>
																				)
																				// 	: (
																				// 	<div
																				// 		style={{
																				// 			width: buttonStyle[
																				// 				"width"
																				// 			],
																				// 			height: buttonStyle[
																				// 				"height"
																				// 			],
																				// 			visibility:
																				// 				visibility[
																				// 					i
																				// 				],
																				// 		}}
																				// 	>
																				// 		<button
																				// 			style={{
																				// 				...buttonStyle,
																				// 				...color[
																				// 					i
																				// 				],
																				// 			}}
																				// 			className={i.toString()}
																				// 			// variant={
																				// 			// 	contained[
																				// 			// 		i
																				// 			// 	]
																				// 			// }
																				// 			onClick={(
																				// 				event
																				// 			) =>
																				// 				handleChoose(
																				// 					event,
																				// 					i
																				// 				)
																				// 			}
																				// 		>
																				// 			{
																				// 				nodesText[
																				// 					i
																				// 				]
																				// 			}
																				// 		</button>
																				// 	</div>
																				// )
																			}
																		</div>
																	);
																}
																return <></>;
															})}
														</div>
													</div>
												)
											);
										})}
										{columnsSelected.includes(
											columns[columns.length - 1]
										) && (
											<div className="toc-column">
												<div
													style={titleStyle}
													className="toc-column-title"
												>
													<div style={titleStyle}>
														{
															columns[
																columns.length -
																	1
															]
														}
													</div>
													<br />
												</div>
												<div
													style={{
														height: "100%",
														display: "flex",
														// padding:
														// 	"50px 20px 50px 20px",
														flexDirection: "column",

														justifyContent: alignTop
															? "flex-start"
															: "space-evenly",
													}}
												>
													{columnsNodes[
														columns[
															columns.length - 1
														]
													].map((i) => {
														if (
															nodesShow.includes(
																i
															)
														) {
															return (
																<div
																	style={{
																		marginTop:
																			marginTop,
																	}}
																>
																	{visibility[
																		i
																	] ===
																		"visible" && (
																		<ArcherElement
																			id={i.toString()}
																			relations={nodesFilter[
																				i
																			][1].map(
																				(
																					node
																				) =>
																					(arrayStyle[
																						i
																					][
																						node
																					][
																						"strokeColor"
																					] ===
																						"var(--stroke-color)" ||
																						checked ===
																							false) && {
																						targetId:
																							node,
																						targetAnchor:
																							"left",
																						sourceAnchor:
																							"right",
																						style: arrayStyle[
																							i
																						][
																							node
																						],
																					}
																			)}
																		>
																			<div
																				style={{
																					width: buttonStyle[
																						"width"
																					],
																					height: buttonStyle[
																						"height"
																					],
																					visibility:
																						visibility[
																							i
																						],
																				}}
																				className="toc-node-container"
																			>
																				<button
																					// disabled={
																					// 	disabled[
																					// 		i
																					// 	]
																					// }
																					style={{
																						...buttonStyle,
																						...color[
																							i
																						],
																						opacity:
																							opacity[
																								i
																							],
																					}}
																					id={i.toString()}
																					className="toc-node toc-node-last"
																					onClick={(
																						event
																					) =>
																						handleChoose(
																							event,
																							i
																						)
																					}
																				>
																					{parse(
																						nodesText[
																							i
																						][0]
																					)}
																				</button>
																			</div>
																		</ArcherElement>
																	)}
																</div>
															);
														}
														return <></>;
													})}
												</div>
											</div>
										)}
									</div>
								</ArcherContainer>
							)}
						</div>
					)}
				</div>
			</ReactSmartScroller>
		</div>
	);
}

export default Base;
